import { LangCodes } from '@tsl-frontend/tsl-locale';
import { AppConfigKeys } from './app-config-keys';

const enUSAppConfig: Record<AppConfigKeys, string> = {
    [AppConfigKeys.USER_REGION]: LangCodes.US,
    [AppConfigKeys.PRIVACY_POLICY_URL]:
        'https://help.thirdspacelearning.com/en/articles/13871475-us-student-privacy-at-third-space-learning',
    [AppConfigKeys.CONTACT_PHONE]: '929-298-4593',
    [AppConfigKeys.PRIMARY_WELCOME_LINK]:
        'https://thirdspacelearning-2.wistia.com/medias/qzy8rmbb1h',
    [AppConfigKeys.SECONDARY_WELCOME_LINK]:
        'https://thirdspacelearning-2.wistia.com/medias/qzy8rmbb1h',
};

export default enUSAppConfig;
